import { render, staticRenderFns } from "./BrandPanel.vue?vue&type=template&id=2742783b&scoped=true"
import script from "./BrandPanel.vue?vue&type=script&lang=js"
export * from "./BrandPanel.vue?vue&type=script&lang=js"
import style0 from "./BrandPanel.vue?vue&type=style&index=0&id=2742783b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742783b",
  null
  
)

export default component.exports